import { render, staticRenderFns } from "./RmIndex.vue?vue&type=template&id=3b8f1a91&"
import script from "./RmIndex.vue?vue&type=script&lang=js&"
export * from "./RmIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports